import {Region} from "src/components/Types";

export const ADSPGlobalBuyingSupportedRegions = [Region.NA, Region.EU, Region.APAC];
export const ADSPGlobalBuyingStringTranslationSuffix = "-manager-account-region";